export default __webpack_public_path__ + "static/media/map-locator.5e3396e3.svg";